export const followUpdate = 'Follow-up Date'
export const profilePicture = 'Profile Picture'
export const signatureText = 'Signature of Doctor with Reg No'
export const usercreation = 'UserCreation'
export const locationcreation = 'Create Location '
export const editlocation = 'Edit Location'
export const OPRegistration = 'OP Registration'
export const getallRegType = 'getallRegType'
export const RegistrationType = 'Registration Type'
export const imageValidationRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i
export const REGISTRATION_TYPES: Record<
  string,
  { text: string; title: string }
> = {
  fr: { text: 'Full', title: 'Full Registration' },
  qr: { text: 'Quick', title: 'Quick Registration' },
  er: { text: 'ER', title: 'Emergency' },
  pmc: { text: 'Pharmacy', title: 'Pharmacy' },
  lab: { text: 'Lab', title: 'Laboratory' },
  dgs: { text: 'Diagnostics', title: 'Diagnostics' },
  camp: { text: 'Campaign', title: 'Campaign' },
  membership: { text: 'MemberShip', title: 'MemberShip' },
  membershipPrimary: { text: 'MemberShip', title: 'MemberShip' },
  ABMembershipQuick: { text: 'AB MemberShip', title: 'AB MemberShip Full' },
  ABMembershipFull: { text: 'AB MemberShip', title: 'AB MemberShip Full' },
  package: { text: 'Package', title: 'Package' },
}
export const unpaid = 'unpaid'
export const roleErrorMessage = 'No Role Assigned To Export Data'
